export default __webpack_public_path__ + "static/media/circut.2955d6ee4320d5d40ff4046f79dd0abc.svg";